import React, { FC } from 'react'

import { defineMessages, useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import { UniNotice } from 'api/uninotice/UniNotice'
import { ErrorIconSvg } from 'components/presentational/svg/ErrorIconSvg'
import { fullPageReload } from 'functions/fullPageReload'
import { replace } from 'functions/router'
import { useLayoutContext } from 'hooks/useLayoutContext'

import { CommonNoticeView } from './CommonNoticeView'
import { UniNoticeId } from './uninotice.types'

const messages = defineMessages({
  title: {
    id: 'app.network_error_title',
    defaultMessage: 'Ошибка сети',
  },
  description: {
    id: 'notification.error',
    defaultMessage: 'Произошла ошибка, попробуйте еще',
  },
  ok: {
    id: 'form.button.ok',
    defaultMessage: 'Понятно',
  },
})

export const NetworkErrorUniNotice: FC = () => {
  const dispatch = useDispatch()
  const intl = useIntl()
  const { baseUrl } = useLayoutContext()

  const handleActionButtonClick = () => {
    dispatch(replace(baseUrl))
    fullPageReload()
  }

  /** TODO надо переписать использование в этом месте */
  return (
    <CommonNoticeView
      notice={
        {
          noticeId: UniNoticeId.network_error,
          payload: {
            textTitle: intl.formatMessage(messages.title),
            text: intl.formatMessage(messages.description),
            imageElement: <ErrorIconSvg width="80px" height="80px" />,
            actionBtn: {
              title: intl.formatMessage(messages.ok),
              action: {
                actionId: 'none',
              },
              type: 'secondary-btn',
            },
          },
        } as UniNotice
      }
      onActionClick={handleActionButtonClick}
    />
  )
}
